/*

REDUX ACTION CREATORS NEED TO BE DEFINED IN THIS FILE AND EXPORTED

*/


import * as types from './actionTypes.js';

//------ CART ACTION CREATORS ------//

export const setCart = (payload) => {
  return {
    type: types.SET_CART,
    payload: payload,
  }
}

export const updateShippingAddress = (payload) => {
  return {
    type: types.UPDATE_SHIPPING_ADDRESS,
    payload: payload,
  }
}

export const updateLineItem = (payload) => {
  return {
    type: types.UPDATE_LINE_ITEM,
    payload: payload,
  }
}

export const deleteLineItem = (payload) => {
  return {
    type: types.DELETE_LINE_ITEM,
    payload: payload,
  }
}

export const setShippingAddress = (payload) => {
  return {
    type: types.SET_SHIPPING_ADDRESS,
    payload: payload,
  }
}

export const updateCustomer = (payload) => {
  return {
    type: types.UPDATE_CUSTOMER,
    payload: payload,
  }
}

export const updateDeliveryDate = (payload) => {
  return {
    type: types.UPDATE_DELIVERY_DATE,
    payload: payload,
  }
}

export const updateBillingAddress = (payload) => {
  return {
    type: types.UPDATE_BILLING_ADDRESS,
    payload: payload,
  }
}

export const updatePayment = (payload) => {
  return {
    type: types.UPDATE_PAYMENT,
    payload: payload,
  }
}

//------ NAVIGATION ACTION CREATORS ------//

export const setCheckoutStep = (payload) => {
  return {
    type: types.SET_CHECKOUT_STEP,
    payload: payload,
  }
}

export const setCanContinue = (payload) => {
  return {
    type: types.SET_CAN_CONTINUE,
    payload: payload,
  }
}

export const setLoading = (payload) => {
  return {
    type: types.SET_LOADING,
    payload: payload,
  }
}

export const setShowError = (payload) => {
  return {
    type: types.SET_SHOW_ERROR,
    payload: payload,
  }
}

export const incrementAttempts = () => {
  return {
    type: types.INCREMENT_ATTEMPTS,
  }
}

export const removeCard = (payload) => {
  return {
    type: types.REMOVE_CARD,
    payload: payload,
  }
}

//------ CUSTOMER INFO ACTION CREATORS ------ //

export const setCustomerInfo = (payload) => {
  return {
    type: types.SET_CUSTOMER_INFO,
    payload: payload,
  }
}

//------ FRONT CONFIG ACTION CREATORS ------//

export const setFrontConfig = (payload) => {
  return {
    type: types.SET_FRONT_CONFIG,
    payload: payload,
  }
}

//------ FRONT CONFIG ACTION CREATORS ------//

export const setShippingSelection = (payload) => {
  return {
    type: types.SET_SHIPPING_SELECTION,
    payload: payload,
  }
}

//------ PAYMENT STATUS ACTION TYPES ------//

export const setPaymentStatus = (payload) => {
  return {
    type: types.SET_PAYMENT_STATUS,
    payload: payload,
  }
}

//------ SHIPPING METHOD ACTION CREATORS ------//

export const setPickupStoreShipping = (payload) => {
  return {
    type: types.SET_PICKUP_STORE,
    payload: payload,
  }
}



//-------EXPANDED TYPES ACTION CREATORS ---------// SET_EXPANDED_TYPE

export const setExpandedType = (payload) => {
  return {
    type: types.SET_EXPANDED_TYPE,
    payload: payload,
  }
}

//-------CONFIRM SCHEDULE TYPES ACTION CREATORS ---------// SET_EXPANDED_TYPE

export const setConfirmSchedule = (payload) => {
  return {
    type: types.SET_CONFIRM_SCHEDULE,
    payload: payload,
  }
}

export const setConfirmationSuccess = (payload) => {
  return {
    type: types.SET_CONFIRMATION_SUCCESS,
    payload: payload,
  }
}

//-------URL PARAMS ACTION CREATORS ---------//

export const setUrlParams = (payload) => {
  return {
    type: types.SET_URL_PARAMS,
    payload: payload,
  }
}

//-------BOOKING ACTION CREATORS ---------//

export const setBooking = (payload) => {
  return {
    type: types.SET_BOOKING,
    payload: payload,
  }
}

